import { API_URL } from "./Config";
import { formatDate } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import {
  GetLicenseeReturnDetailsAsync,
  ILicenseeReturnDetails,
} from "./ILicenseeReturns";
import { GetLicenseDetailsAsync } from "./LicenceDetails";

export interface IInstruction {
  epainitiatedcorrespondenceid: string;
  reference: string;
  subject: string;
  status: string;
  datesubmitted: string;
  duedate: string;
  licensingnotification: string;
  correspondencetype: string;
  regno: string;
  licenseesubmissionid: string;
}

export interface IInstructionDetails extends IDetailsResponse {
  epainitiatedcorrespondenceid: string;
  reference: string;
  subject: string;
  status: string;
  datesubmitted: string;
  duedate: string;
  licensingnotification: string;
  correspondencetype: string;
  regno: string;
  licenseesubmissionid: string;
  licenseeReturn?: ILicenseeReturnDetails;
  profileNo: string;
}

export const GetInstructionsFromLicenseeReturnFetchUrl = (
  licenseeReturnId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }
  let url = `${API_URL}/LicenseeReturns/lrintructionlistbylrid?lr_id=${licenseeReturnId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/instructions-by-licensee-return`;
  }

  return url;
};

export async function GetInstructionDetailsAsync(
  instructionId: string
): Promise<IInstructionDetails> {
  var url = `${API_URL}/LicenseeReturns/lrintructionbyid?lrintruction_id=${instructionId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/instruction-details`;
  }

  var response = await fetch(url);
  var body = <IInstructionDetails>await response.json();

  const licenseeReturnDetails = await GetLicenseeReturnDetailsAsync(
    body.licenseesubmissionid
  );
  const licenceDetails = await GetLicenseDetailsAsync(
    licenseeReturnDetails.licenceid
  );

  return <IInstructionDetails>{
    response: response,
    epainitiatedcorrespondenceid: body.epainitiatedcorrespondenceid,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    licensingnotification: body.licensingnotification,
    correspondencetype: body.correspondencetype,
    regno: body.regno,
    licenseesubmissionid: body.licenseesubmissionid,
    licenseeReturn: licenseeReturnDetails,
    profileNo: licenceDetails.licenceprofile_number,
  };
}
